import {LOG_IN, LOG_OUT, LOG_VERIFICAR} from './authTypes';
const usuarioDev = {
   codigo: '00',
   nombre: 'Desarrollo',
   apPaterno: 'Data',
   apMaterno: 'Service',
   usuario: 'DEV',
   email: 'dev@dscont.pe',
   condicion: 'Contratado',
   sucursal: 'CUS',
   avatar: '',
   especialidad: 'Programador',
   sistema: 'desarrollo',
   key: '25641ed8-bd91-4876-b361-e9909be07cec'
};
const initialState = {
   logged: false,
   intentoVerificar: false,
   msg: '',
   usuario: {},
   token: ''
};

function authReducer(state = initialState, action) {
   switch (action.type) {
      case LOG_OUT:
         return {...state, logged: false, token: initialState.token, usuario: initialState.usuario};
      case LOG_VERIFICAR:
         if (process.env.REACT_APP_DS_ENV === 'PROD') {
            return {...state, ...action.payload};
         } else {
            return {...state, intentoVerificar: true, logged: true, usuario: usuarioDev};
         }
      case LOG_IN:
         const {configUser,...otros}=action.payload;
         return {...state, ...otros, ...configUser};
      default:
         return state;
   }
}

export default authReducer;
